export interface NewsArticle {
  id: string;
  title: string;
  summary: string;
  date: string;
  tag: string;
  author: string;
  relatedWorkId: string;
  content: string[];
}

export const newsList: NewsArticle[] = [
  {
    id: "news-2026-jiaxinju",
    title: "《女友的妈妈：迟到的家宴》定档十月，首支预告揭晓四副碗筷之谜",
    summary:
      "影片公布正式档期与首支预告片，导演陈砚舟透露，片中那场长达四十分钟的晚宴只拍了两条，演员全部采用真实情绪完成。",
    date: "2026-10-15",
    tag: "新片定档",
    author: "影视专区编辑部",
    relatedWorkId: "huanying-jiadao",
    content: [
      "备受关注的家庭题材影片《女友的妈妈：迟到的家宴》今日正式公布档期，并释出首支预告。预告以一段长达九十秒的沉默开场：雨夜、老宅、摆了四副碗筷的餐桌，随后才是第一句对白。",
      "导演陈砚舟在采访中表示，这场晚宴是全片的核心，也是拍摄难度最大的一场戏。「我们只拍了两条，第二条结束后所有人都没有立刻离开片场。有些情绪是演不出来的，只能等它自己到。」",
      "饰演女友母亲沈婉宁的演员周婉宁此次挑战大量克制型表演，她透露自己在开拍前专门去拜访了几位退休的电影放映员，观察他们聊到旧事时下意识的小动作。",
      "影片将于本月下旬上线高清版，本站会持续跟进后续的幕后特辑与主创访谈，并整理成专题页供观众查阅。",
    ],
  },
  {
    id: "news-2026-yuxiang",
    title: "雨巷里的约定 收官特辑：双时间线如何被剪成一条完整的情绪线",
    summary:
      "剧集完结后释出的剪辑特辑中，主创团队公开了从三百小时素材到终版的取舍过程，也解答了观众最关心的「伞到底是谁的」这一问题。",
    date: "2026-10-12",
    tag: "幕后特辑",
    author: "剧情研究组",
    relatedWorkId: "yuwang-qiutian",
    content: [
      "开播三个月后，《雨巷里的约定》以 8.8 的评分收官。剧集最大的看点在于双时间线的交叉叙事：当下的城市日常与旧剧本里的黑白青春彼此反射，最终在最后一集汇合。",
      "剪辑师在特辑中说明，全剧共有三百余小时的素材，最终剪成二十四集。为了让两条时间线不显得割裂，他们为过去的一条线统一做了轻微的褪色处理，并在每次切换前保留一段环境音。",
      "至于观众讨论了整个播出季的「伞到底是谁的」，编剧给出的回答是：「伞属于那条巷子。谁经过，谁就可以拿着它走一段。」",
    ],
  },
  {
    id: "news-2026-sanlou",
    title: "三楼的灯总是亮着 4K 修复上线，旧楼取景地成为影迷打卡点",
    summary:
      "影片完成 4K 修复重映，原本计划拆除的取景旧楼被当地列入保留名单，片中那盏灯也保留在楼梯间原处。",
    date: "2026-10-08",
    tag: "修复重映",
    author: "影视专区编辑部",
    relatedWorkId: "sanlou-dengpao",
    content: [
      "《三楼的灯总是亮着》本周以 4K 修复版重新上线。修复团队表示，影片原底片存在明显的夜戏噪点问题，这次修复在保留颗粒感的前提下重做了暗部层次。",
      "更有趣的是，影片的取景地——一栋建于上世纪六十年代的旧居民楼——因为影片的传播而重新被人关注。当地社区在居民联名申请后，暂缓了拆除计划，并将楼梯间那盏灯保留在原处。",
      "导演梁世衡在社交平台回应：「那盏灯本来就是别人家的，我们只是借来拍了十天。」",
    ],
  },
  {
    id: "news-2026-dishifang",
    title: "从《第十坊间》看古装探案剧的「单元化」新解法",
    summary:
      "播出三年后依然是议题之作，这部剧用「一坊一案」的结构把长安城拆成三十二个可以独立观看的切片。",
    date: "2026-09-29",
    tag: "深度解读",
    author: "剧情研究组",
    relatedWorkId: "dishifang-jian",
    content: [
      "近年古装探案剧数量不少，但《第十坊间》的结构依然特别：三十二集，每一坊对应一个相对独立的案件，彼此之间只在人物的处境上产生联系。",
      "这种结构的好处在于观剧门槛低，任何一集进入都不会完全迷失；代价则是主线推进缓慢，需要观众自己拼合线索。为此编剧在每个单元里埋入了同一只漆盒的不同细节。",
      "在第三十二集，漆盒被彻底打开，里面并没有信件，而是一张早已失效的坊门钥匙图。这个处理被不少观众视为全剧最漂亮的一笔。",
    ],
  },
  {
    id: "news-2026-changye",
    title: "《长夜与灯》导演剪辑版新增二十分钟：风雪中的沉默被重新填满",
    summary:
      "导演郑泊远重新调色并加长段落，新增内容主要集中在中段雪地行走的部分，让队伍里每个人的过往更加完整。",
    date: "2026-09-21",
    tag: "导演剪辑",
    author: "影视专区编辑部",
    relatedWorkId: "chang-an-xian",
    content: [
      "导演剪辑版将片长从一百二十二分钟延长到一百四十二分钟，新增内容几乎全部集中在中段：队伍在雪原上遭遇迷失的四天。",
      "郑泊远表示，公映版本为了让节奏更紧凑，删去了大量「什么都没有发生」的段落，但那些段落恰恰是这部电影想留下的东西。",
      "新版同时对夜戏做了重新调色，整体色调从偏冷改为带一点暖意，让远处那盏灯的存在感更明确。",
    ],
  },
  {
    id: "news-2026-jinxiu",
    title: "《锦绣园旧事》推出舞台剧版本，三代女人将在同一个舞台上同场",
    summary:
      "剧集改编舞台剧定档明年春季，制作方透露将以三条平行舞台同时展开叙事，观众可自行选择视线焦点。",
    date: "2026-09-16",
    tag: "跨界改编",
    author: "影视资讯组",
    relatedWorkId: "jinxiu-yuan",
    content: [
      "年代剧《锦绣园旧事》宣布改编为舞台剧。与剧集的线性叙事不同，舞台版本将把三代女性的故事放在三个相邻的舞台上同步进行。",
      "导演柯明川解释：「观众不需要看懂全部，只要在某一刻被某一个人吸引就足够了，这正是剧里日记的感觉。」",
      "舞台剧将保留剧集结尾那只旧罐子的意象，并在散场时让观众从园子的另一条路径离开。",
    ],
  },
  {
    id: "news-2026-wuye",
    title: "午夜剧场 特别版上线：那卷「未命名胶片」是怎么做出来的",
    summary:
      "美术指导分享片中那卷插入的伪纪录片片段，全部在真实的老影院里用十六毫米胶片实拍完成，没有使用任何数字修复。",
    date: "2026-09-10",
    tag: "制作揭秘",
    author: "剧情研究组",
    relatedWorkId: "wuren-zhixiao",
    content: [
      "《午夜剧场》最被津津乐道的段落，是那卷突然插入的「未命名胶片」。观众一度以为这些画面来自真实的旧影像素材。",
      "美术指导在采访中澄清，所有片段都是为影片专门拍摄的：使用十六毫米胶片，用一台已经停产的放映机放映、再重新翻拍一遍，保留划痕与跳帧。",
      "「数字修复太快了，」他说，「我们要的是那种胶片被播放了两千次之后才有的迟疑。」",
    ],
  },
  {
    id: "news-2026-guifan",
    title: "《规范生活》开播口碑走高，观众热议「清单式人生」",
    summary:
      "这部都市轻喜剧用二十七张清单讨论秩序与自由，开播三周评分稳定在 8.2，成为本季讨论度最高的职场剧之一。",
    date: "2026-10-03",
    tag: "热播追踪",
    author: "影视资讯组",
    relatedWorkId: "guifan-shenghuo",
    content: [
      "《规范生活》开播三周，凭借轻松的表达方式与准确的生活细节，在观众中收获了相当稳定的口碑。",
      "主角程一舟的二十七张清单成了社交平台上的模仿对象，不少观众晒出自己的「一日任务表」，并戏称自己是清单体。",
      "剧集并未把秩序感简单处理为笑点，第十二集里主角删掉日程表的那一段，被许多观众评为本季最动人的场景。",
    ],
  },
  {
    id: "news-2026-haian",
    title: "海岸线 重映：那段海岸线取景地已变成风力电厂",
    summary:
      "影片上映三年后重映，取景的旧海堤已被拆除，取而代之的是一排风力发电机，导演在重映首映礼上谈及这件事。",
    date: "2026-09-02",
    tag: "修复重映",
    author: "影视专区编辑部",
    relatedWorkId: "hai-an-xian",
    content: [
      "《海岸线》重映首映礼上，导演林见野播放了一段新拍摄的对照视频：同一段海岸线，三年前是空荡的混凝土海堤，如今是一排白色的风力发电机。",
      "「我们拍的不是风景，是那个夏天。」他说，「风景会变，夏天不会。」",
      "重映版保留原片画幅，只在音轨上做了重新混录，海浪声变得更清晰。",
    ],
  },
  {
    id: "news-2026-bailu",
    title: "《白露园谶》美术设计解析：一片白花与四十盏灯",
    summary:
      "主创团队公开白露园的场景设计手稿，从花的开花时间到灯笼的悬挂高度，都经过精确计算。",
    date: "2026-08-26",
    tag: "幕后特辑",
    author: "影视资讯组",
    relatedWorkId: "bailu-yuan",
    content: [
      "《白露园谶》的美术团队公开了场景设计手稿。白露园的核心元素只有两个：白色的花和橘色的灯。",
      "为了拍出「不该开的花」的效果，剧组在棚内搭建了一片可控温的花园，通过调节湿度让花期集中在拍摄的十天之内。",
      "灯笼的悬挂高度也有讲究：随着剧情推进，灯的高度逐集降低，直到最后一集完全坐落在石阶上，暗示记忆正在落地。",
    ],
  },
  {
    id: "news-2026-qipai",
    title: "影院第七排：那部被重映十年的老片究竟是谁拍的",
    summary:
      "影片留下的开放式疑问持续被讨论，编剧给出了一个相当温和的答案：「片名我们已经写在片尾了，只是没人注意。」",
    date: "2026-08-18",
    tag: "深度解读",
    author: "剧情研究组",
    relatedWorkId: "dianying-yuan-xinnian",
    content: [
      "《电影院的第七排》上映以来，「那部被重映十年的老片」成了观众最关心的问题。片中只出现了几个片段，从未交代导演与片名。",
      "编剧罗一川在影迷活动上回应：「片名我们写在片尾的第一行，但它是用手写体，而且只有一秒。你可以把它理解成片中那个修表匠的名字。」",
      "他还补充，这个处理并不打算制造复杂的谜题，只是想让观众离场时带走一个不需要答案的念头。",
    ],
  },
  {
    id: "news-2026-changye-weimian",
    title: "《长夜未眠》获年度最佳摄影提名，雨夜戏全部实景完成",
    summary:
      "摄影指导透露全剧的雨夜场景没有使用数字降雨，全部依靠真实的台风雨与灯光完成，全组在暴雨中拍了十九个通宵。",
    date: "2026-08-09",
    tag: "奖项动态",
    author: "影视资讯组",
    relatedWorkId: "chang-ye-wei-mian",
    content: [
      "《长夜未眠》获得年度最佳摄影提名。摄影指导在访谈中表示，全剧的雨夜戏份全部为实景拍摄，没有使用任何数字降雨与绿幕补拍。",
      "剧组为此调整了整个拍摄计划，追着当年的台风季节走：前后十九个通宵，只要下雨就开机，晴天则补拍室内戏。",
      "「雨落在不同材质上的声音完全不一样，」他说，「这是数字做不出来的。」",
    ],
  },
];